import { Modal } from '../modal';
import Body from './body';
import DialogInternal from './dialog-internal';
import Footer from './footer';
import Header from './header';
const DialogNamespace = Object.assign(DialogInternal, {
    Body,
    Button: Modal.Button,
    CloseButton: Modal.CloseButton,
    Footer,
    Header,
});
export default DialogNamespace;
